export const MINIMUM_TAGS_COUNT = 3;
export const MINIMUM_REVIEWS_WITH_TEXT = 5;
export const POSITIVE_SENTIMENTS_RATING_THRESHOLD = {
    MINIMUM_GOOD_THRESHOLD: 0.8,
    MINIMUM_AVERAGE_THRESHOLD: 0.6,
};
